module.exports = __webpack_public_path__ + "static/media/left-arrow.cd69b24b.svg";